import React, { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import Navigation from './src/navigation/Navigation';
import { PopupProvider } from './src/contexts/PopupContext';
import './src/styles/global.css';
import { applyGlobalStyles } from './src/utils/styleUtils';

export default function App() {
  useEffect(() => {
    applyGlobalStyles();
  }, []);

  return (
    <PopupProvider>
      <View style={styles.container}>
        <Navigation />
      </View>
    </PopupProvider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    backgroundColor: '#000000',
    position: 'relative',
    overflow: 'hidden',
  },
});


